var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.469.469c-6.628 0-12 5.372-12 12 0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12Zm0 22.641c-5.869 0-10.642-4.773-10.642-10.64S6.601 1.827 12.47 1.827c5.868 0 10.641 4.774 10.641 10.642 0 5.868-4.773 10.641-10.641 10.641Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.984 13.99v-.666c0-.505.103-.932.31-1.28.206-.348.572-.687 1.098-1.017.418-.262.718-.5.9-.711a1.08 1.08 0 0 0 .276-.727.585.585 0 0 0-.295-.514c-.195-.127-.45-.19-.765-.19-.779 0-1.689.276-2.73.828L8.703 7.609c1.283-.732 2.624-1.098 4.021-1.098 1.15 0 2.052.252 2.707.758.655.505.983 1.193.983 2.065 0 .624-.146 1.164-.438 1.62-.29.456-.756.888-1.396 1.295-.541.351-.88.608-1.017.77a.866.866 0 0 0-.204.576v.394h-2.375Zm-.332 2.707c0-.475.138-.84.414-1.099.275-.258.682-.387 1.218-.387.515 0 .911.13 1.187.391.276.26.414.625.414 1.095 0 .469-.143.832-.43 1.09-.286.258-.676.387-1.171.387-.51 0-.91-.128-1.2-.383-.288-.255-.432-.62-.432-1.094Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.0bfbf70479bfc5af4d95b7aa72edf70e.svg";
export { ForwardRef as ReactComponent };